export default "__VITE_ASSET__ChLvujx4__"